import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './app/router';
import { preloadFonts } from './lib/preload-fonts';
import '@chronospeak/ui/tokens.css';
import '@chronospeak/ui/fonts.css';
import '@chronospeak/ui/ui.css';
import './styles/global.css';

preloadFonts();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
